<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-chapter3" id="toc-preface002"><a href="#/preface002">Preface</a></p>
<p class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">1. The Camp</a></p>
<p class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">2. The Battle of Cunaxa</span></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">3. Xenophon Takes Action</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">4. Kurdestan</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">5. Winter</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">6. The Sea</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">7. Discipline Breaks Down</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">8. Back to Europe</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">9. The Last Adventure</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3e6b144c